module.exports = __webpack_public_path__ + "assets/img/i.692fa5ac.png";